import axios from 'axios'
const rax = require('retry-axios')
rax.attach()

export const state = {
  all: [],
  loaded: false,
}

export const getters = {}

export const mutations = {
  SET_ALL(state, newProperties) {
    state.all = newProperties.map((property) => {
      return {
        ...property,
        name:
          property.officialName +
          (property.nickname && ` (${property.nickname})`),
        mainPhoto: property.images.length
          ? property.images.find((image) => image.mainPhoto) ||
            property.images[0]
          : undefined,
        amenities: {},
      }
    })
  },
  SET_LOADED(state, newValue) {
    state.loaded = newValue
  },
  SET_PROPERTY_AMENITIES(state, { id, amenityType, value }) {
    const property = state.all.find((property) => property.id === id)
    property.amenties[amenityType] = value
  },
}

export const actions = {
  fetchAll({ state, commit }) {
    if (state.loaded) return state.all

    return axios
      .get('/api/properties')
      .then((response) => {
        const { properties } = response.data
        commit('SET_ALL', properties)
        commit('SET_LOADED', true)
        return state.all
      })
      .catch((error) => {
        commit('SET_LOADED', true)
        console.error(error)
      })
  },

  fetchNearbyAmenitiesForProperty({ state, commit }, { id }) {
    const property = state.all.find((property) => property.id === id)
    // Abort if we've already fetched amenities
    if (Object.keys(property.amenities).length) return
    ;[
      'park',
      'hospital',
      'bus_station',
      'library',
      'supermarket',
      'convenience_store',
      'post_office',
      'pharmacy',
      'school',
      'shopping_mall',
      'restaurant',
    ].forEach((amenityType) => {
      axios
        .get('/api/nearby-amenities', {
          params: {
            latitude: property.address.latitude,
            longitude: property.address.longitude,
            type: amenityType,
          },
        })
        .then((response) => {
          if (!response.data.amenities.length) return

          commit('SET_PROPERTY_AMENITIES', {
            id,
            amenityType,
            value: response.data.amenities,
          })
        })
    })
  },
}
